import { getDataOfType } from 'src/lib/utils/get-data-of-type'

export function getFiledRules(props: any, requiredUISchema: boolean): any[] {
  const { required, type, format } = props as { required: boolean, type: string, format?: string }
  const isString = type === 'string'
  if (isString && format === 'email') {
    return [{ type: 'email', required, message: 'Неверный формат' }]
  }
  return [{ required: requiredUISchema, message: 'Обязательное поле' }]
}

export function getUISchemaValue(UISchema: any, key: string){
  return getDataOfType(UISchema, key, Object, null)
}


